interface RouteProps {
  href: string;
  label: string;
}

export const routeList: RouteProps[] = [
  {
    href: "/#features",
    label: "Features",
  },
  {
    href: "/#pricing",
    label: "Pricing",
  },
  {
    href: "/calgary-vacancy",
    label: "Calgary",
  },
  {
    href: "/edmonton-vacancy",
    label: "Edmonton",
  },
  {
    href: "/vancouver-vacancy",
    label: "Vancouver",
  },
  {
    href: "/toronto-vacancy",
    label: "Toronto",
  },
  {
    href: "/ontario-vacancy",
    label: "Ontario",
  },
];
